module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (179).c14f2cbb.jpg";